const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  roles: state => state.user.roles,
  name: state => state.user.name,
  corporation: state => state.user.corporation,
  corporationID: state => state.user.corporationID,
  corporationName: state => state.user.corporationName,
  balance: state => state.user.balance,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  permission_routes: state => state.permission.routes,
  transaction: state => state.transaction,
  transactionCorporationID: state => state.transaction.corporationID,
  transactionCorporationName: state => state.transaction.corporationName,
  limitllMoney: state => state.settings.limitllMoney,
  user: state => state.user.user,
  sort: state => state.sort,
  getNotice: state => state.notice,
  roleAuthList: state => state.user.roleAuthList
};
export default getters;